const log = {
    invalid_type: 'ログタイプが無効です。',
};
export default log;
